var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"nonzero","d":"M5.5 3a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zm0 7.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zm0 7.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }